// source of languages:  https://gist.github.com/Josantonius/b455e315bc7f790d14b136d61d9ae469
export type LanguageCode = "en" | "zh-hk" | "id" | "tl"; // Add all valid language codes here

export type MultiLingual = {
    [key in LanguageCode]?: string;
};

export type LanguageSelectModel = {
    label: string,
    value: LanguageCode
}

export const languages: LanguageSelectModel[] = [
  { label: 'English', value: 'en' },
  { label: 'Cantonese', value: 'zh-hk' },
  { label: 'Bahasa Indonesia', value: 'id' },
  { label: 'Tagalog', value: 'tl' },
  // Add more languages as needed
];

export const defaultLanguage : LanguageCode = 'en';

export function getDefaultOrFirstLang(
  data: MultiLingual,
  defaultLang: LanguageCode = defaultLanguage
): string | undefined {
  // Return the default language if it exists
  if (data[defaultLang]) {
      return data[defaultLang];
  }
  // Return the first available language
  for (const key of Object.keys(data) as LanguageCode[]) {
      if (data[key]) {
          return data[key];
      }
  }
  // No language found
  return undefined;
}